import PropTypes from 'prop-types';
import React from 'react';

const getTitle = (title, onCutText, maxLength) => {
  if (onCutText && maxLength) {
    return onCutText(title, maxLength);
  }

  return title;
};

const ProductCategoryNameLazy = ({
  isLoaded,
  isLoading,
  title,
  onCutText,
  maxLength,
}) => (
  <span title={title}>
    {isLoading ? '...' : ''}{' '}
    {isLoaded ? getTitle(title, onCutText, maxLength) : ''}
  </span>
);

ProductCategoryNameLazy.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onCutText: PropTypes.func,
  maxLength: PropTypes.number,
};

ProductCategoryNameLazy.defaultProps = {
  title: null,
  onCutText: null,
  maxLength: null,
};

export default ProductCategoryNameLazy;
